import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Paprika } from '../../../../styles/theme';

interface Props {
  source?: string | null;
}

function getDomain(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

export function SourceBadge({ source }: Props) {
  if (!source) return null;
  const isUrl = source.startsWith('http');
  const label = isUrl ? getDomain(source) : 'Du Chef';
  return (
    <View style={styles.badge}>
      <Text style={styles.text} numberOfLines={1}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    backgroundColor: Paprika.bgSunk,
    borderRadius: 4,
    paddingHorizontal: 6,
    paddingVertical: 2,
    alignSelf: 'flex-start',
    maxWidth: 120,
  },
  text: {
    fontFamily: 'Inter-Regular',
    fontSize: 11,
    color: Paprika.textMuted,
  },
});
